enum FactType {
    SHORT_TEXT = 'short-text',
    MEDIUM_TEXT = 'medium-text',
    LONG_TEXT = 'long-text',
    OPTION = 'option',
}

export default FactType